import React from "react";
import classNames from "classnames";
import constants from "../../../../../globalization";
import classes from "./CheckDetails.module.css";
import FBCommonUtil from '../../../../Fireboard/common';

const FireboardTip = (props) => {
  const {
    selectedItem: { selectedCheckDetails = {} },
    currency='$',
    suppressTipsOnFireBoard,
  } = props || {};

  const getTipPercent = () => {
    const { tipAmount, paidAmount } = selectedCheckDetails;
    let tipPercent = 0;
    if (paidAmount !== 0) {
      tipPercent = tipAmount / paidAmount;
    }
    return tipPercent ? `(${(tipPercent * 100).toFixed(2)}%)` : '';
  };

  const itemsCount = FBCommonUtil.getItemCount(selectedCheckDetails.items);

  const getValue = field => {
    if (selectedCheckDetails[field]) {
      return `${currency}${selectedCheckDetails[field].toFixed(2)}`;
    }
    return '';
  };

  return (
    <div className={classNames({ [`${classes.bottomContainer}`]: true , [`${classes.marginForBottomContainer}`]: itemsCount > 5})}>
      <div className={classes.toolTipContainer}> 
        <div className={classes.tooltipItemContainer}>
          <span className={classes.toolTipHeaderText}>{constants.tipSubTotal.toUpperCase()}</span>
          <span className={classes.toolTipText}>{getValue('subTotalAmount')}</span>
        </div>
        <div className={classes.tooltipItemContainer}>
          <span className={classes.toolTipHeaderText}>{constants.taxLabel}:</span>
          <span className={classes.toolTipText}>{getValue('taxAmount')}</span>
        </div>

        {suppressTipsOnFireBoard ? null : (<div className={classes.tooltipItemContainer}>
          <span className={classes.toolTipHeaderText}>{constants.fireboardTip}:</span>
          <span className={classes.toolTipText}>{`${getValue('tipAmount')} ${getTipPercent()}`}</span>
        </div>)}

        <div className={classes.tooltipItemContainer}>
          <span className={classes.toolTipHeaderText}>{constants.due}:</span>
          <span className={classes.toolTipText}>{getValue('totalAmount')}</span>
        </div>
        <div className={classes.tooltipItemContainer}>
          <span className={classes.toolTipHeaderText}>{constants.checkHistoryPaid.toUpperCase()}:</span>
          <span className={classes.toolTipText}>{getValue('paidAmount')}</span>
        </div>
        <div className={classes.tooltipItemContainer}>
          <span className={classes.toolTipHeaderText}>{constants.checkHistoryUnpaid.toUpperCase()}:</span>
          <span className={classes.toolTipText}>{getValue('unpaidAmount')}</span>
        </div>
    </div>
    </div> 
  );
};

export default FireboardTip;
